import { render, staticRenderFns } from "./priorat.vue?vue&type=template&id=1c57940e&scoped=true"
import script from "./priorat.vue?vue&type=script&lang=js"
export * from "./priorat.vue?vue&type=script&lang=js"
import style0 from "./priorat.vue?vue&type=style&index=0&id=1c57940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57940e",
  null
  
)

export default component.exports